import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { isStaff } from '@utils/getRole';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const customerDeliveryFileUploadStopService = (data: any) => {
  const URL = isStaff
    ? ENDPOINTS.STAFF.CUSTOMER_DELIVERY.UPLOAD.STOP
    : ENDPOINTS.ADMIN.CUSTOMER_DELIVERY.UPLOAD.STOP;

  return axiosInstance
    .post(URL, data)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
